import MessageTemplateManagementContainer from './MessageTemplate/MessageTemplateManagementContainer';
import MessageSendContainer from './MessageSend/MessageSendContainer';
import MessageListContainer from './MessageList/MessageListContainer';

export const MessageIndex = {
  MessageTemplateManagementContainer,
  MessageSendContainer,
  MessageListContainer,
};
